import React from 'react'
import styled from 'styled-components'
import {Create, Delete} from '@mui/icons-material'

const Tab = styled.div`
    flex-shrink: 0;
    margin-right: 10px;
    background-color: ${props => props.active ? '#3c3d4c' : '#E9EEF0'};
    color: ${props => props.active ? '#fff' : 'rgb(74, 74, 74)'};
    padding: 0 5px;
    align-items: center;
    border-radius: 2px;
    cursor: pointer;
    font-size: 13px;
    display: flex;
    height: 40px;
    width: ${props => props.size}px;
    user-select: none;
    box-sizing: border-box;

    :last-child {
        margin-right: 0;
    }

    > svg {
        padding-left: 5px;
        font-size: 20px;
        cursor: pointer;
        margin-left: auto;
    }
`

const Name = styled.div`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`

class View extends React.PureComponent {
    onDragStart = (e) => {
        e.preventDefault()
        e.stopPropagation()
        this.props.onDragStart(e, this.props.id)
    }

    onEdit = (e) => {
        e.stopPropagation()
        this.props.handleClick(e, this.props.id, 'view')
    }

    onDelete = (e) => {
        e.stopPropagation()
        this.props.handleClick(e, this.props.id, 'exclude')
    }

	onSelect = () => {
		this.props.handleSelectView(this.props.id)
	}

    render() {
        return (
            <Tab
                draggable={this.props.default ? false : true}
                data-view={this.props.id}
                onClick={this.onSelect}
                active={this.props.active}
                onDragStart={this.props.permissions && !!this.props.id ? this.onDragStart : undefined}
                size={this.props.size}
            >
                <span className={"entity-icon-small entity-icon-" + this.props.icon} />
                <Name> {this.props.name} </Name>
                {this.props.active && !this.props.default && this.props.permissions &&
                    <Create onClick={this.onEdit} />
                }
                {this.props.active && this.props.default && this.props.count > 1 && this.props.permissions &&
                    <Delete onClick={this.onDelete} />
                }
            </Tab>
        )
    }
}

export default View
